import axios, { buildApi } from '@/libs/api.request';
let name = '/report/sms'

export const apis = buildApi({
  get: [name + '/index&list', name + '/sync'],
})